import React, { useEffect, useState } from "react";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import useMediaQuery from "@mui/material/useMediaQuery";

/**
 * V2 copy of components/QuoteRadioForm — re-colored with v2 CSS variables so it
 * themes. Renders the interior/exterior, discount, and heard-about-us choices.
 */
const QuoteRadioFormV2 = (props) => {
  const {
    name,
    question,
    choices,
    choiceDefault,
    formId,
    choiceStateFunction,
    endComponent,
    mediaQueryWidth,
    forceRow,
  } = props;

  const mediaQuery = useMediaQuery(mediaQueryWidth || "(min-width: 760px)");
  const [selectionState, setSelectionState] = useState(null);

  useEffect(() => {
    if (choiceDefault) {
      setSelectionState(choiceDefault);
    }
  }, [choiceDefault]);

  return (
    <FormControl id={formId} className="bdrv2-radio-form">
      <FormLabel
        sx={{
          color: "var(--v2-text)",
          "&.Mui-focused": { color: "var(--v2-text)" },
        }}
      >
        <span className="bdrv2-radio-question">{question}</span>
        <RadioGroup
          aria-labelledby={formId}
          defaultValue={choiceDefault}
          value={selectionState}
          onChange={(event) => {
            choiceStateFunction(event);
            setSelectionState(event?.target?.value);
          }}
          name={name}
          {...(mediaQuery ? { row: forceRow || true } : { row: forceRow || false })}
          className="bdrv2-radio-group"
        >
          {choices.map((choice, index) => (
            <FormControlLabel
              key={choice + index}
              value={choice}
              sx={{ color: "var(--v2-text)" }}
              control={
                <Radio
                  sx={{
                    color: "var(--v2-text-faint)",
                    "&.Mui-checked": { color: "var(--v2-accent)" },
                  }}
                />
              }
              label={choice}
            />
          ))}
        </RadioGroup>
        {endComponent ? endComponent : null}
      </FormLabel>
    </FormControl>
  );
};

export default QuoteRadioFormV2;
